import React from "react";

interface Props {
  className?: string;
}

const Moon = ({ className }: Props) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 223 223"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="111.5" cy="111.5" r="111.5" fill="#6F6E83" />
    <path
      d="M111.5 222.999C173.08 222.999 223 173.079 223 111.499C223 59.0234 186.749 15.0144 137.923 3.14893C83.3053 13.9239 42 63.9338 42 124C42 162.927 59.3482 197.631 86.4253 220.169C94.485 222.021 102.878 222.999 111.5 222.999Z"
      fill="#ADACC2"
    />
    <g opacity="0.4">
      <path
        d="M101.22 222.532C101.763 221.832 102.058 221.152 102.029 220.496C93.953 219.709 56.0228 209.565 60.1394 201.587C64.6579 200.941 70.9973 201.738 77.3115 202.53C88.9039 203.986 100.412 205.431 100.412 197.926C106.88 201.449 103.21 194.931 99.1582 187.736C95.554 181.335 91.6481 174.398 94.3098 173.518C100.806 175.952 107.105 182.57 113.001 188.765C120.502 196.646 127.352 203.843 133.128 200.867C151.316 191.493 159.773 169.706 165.862 154.019C165.954 153.782 166.045 153.547 166.136 153.313C171.281 150.872 170.369 158.494 169.392 166.665C168.544 173.755 167.646 181.258 170.611 182.964C178.583 182.964 187.941 174.625 194.45 168.825C199.251 164.548 202.501 161.652 202.5 164.502C202.5 168.171 196.952 177.335 191.617 186.146C190.159 188.554 188.717 190.936 187.408 193.172C167.504 211.68 140.824 223 111.5 223C108.034 223 104.605 222.842 101.22 222.532Z"
        fill="#BAB7D1"
      />
      <path
        opacity="0.5"
        d="M94.0253 140.239C95.3756 141.167 96.7421 142.15 98.1095 143.134C104.281 147.574 110.469 152.026 115.248 151.5C118.935 151.094 116.905 147.886 114.406 143.938C112.044 140.205 109.263 135.812 110.501 132.5C113.652 130.912 117.721 131.361 121.054 131.729C125.069 132.172 128.016 132.497 127.001 129C126.447 127.092 124.916 124.437 122.936 121.477C121.441 118.295 119.314 114.438 117.432 111.024C115.663 107.815 114.11 104.997 113.499 103.5C112.169 100.238 115.423 103.389 119.281 107.126C121.019 108.81 122.88 110.612 124.5 112C135 121 148.106 120.5 158.5 112C161.159 109.825 157.197 109.654 151.902 109.425C145.946 109.168 138.303 108.837 136.5 105.5C133.986 100.848 139.68 96.6433 144.819 92.8478C151.832 87.6684 157.812 83.2512 140.5 79.5C135.502 78.4172 141.44 71.4987 148.126 63.7075C154.431 56.3609 161.402 48.2383 160.5 43.5002C159.522 38.3659 156.273 41.4802 151.98 45.595C147.493 49.8954 141.866 55.2887 136.501 53.5003C130.393 51.4644 136.448 38.6069 141.086 28.7567C144.809 20.8517 147.619 14.8835 142.499 17.9999C141.161 18.8144 139.399 19.4412 137.349 20.1707C134.426 21.2108 130.916 22.4593 127.215 24.7575C127.167 24.566 127.11 24.3755 127.044 24.1859C124.877 17.9472 115.796 14.266 108.469 14.9524C104.246 15.348 100.974 18.3856 97.6935 21.4308C94.4832 24.4109 91.265 27.3982 87.1409 27.9239C84.4463 28.2674 82.2717 28.1592 80.3061 28.0615C76.6916 27.8817 73.7835 27.737 69.6474 30.5001C65.6915 33.1428 65.6109 34.9989 65.5163 37.1757C65.4351 39.0469 65.3435 41.1551 62.7715 44.2035C65.4546 56.4458 56.5483 56.52 49.1835 56.5813C44.9398 56.6166 41.2079 56.6477 40.4998 58.9999C36.2716 63.6311 37.6384 63.1537 40.3551 62.2048C43.888 60.9708 49.7034 58.9396 48.4658 66.3086C48.2212 66.5007 47.9785 66.6954 47.7377 66.8929C44.7083 69.3782 44.6091 73.7121 44.5082 78.1208C44.4318 81.4616 44.3543 84.8452 43.0001 87.4998C21.0011 79.9998 25.0001 91.9998 29.3884 102.862C23.0945 109.034 26.6709 110.164 30.9302 111.511C35.3928 112.921 40.605 114.569 36.0001 122.5C37.4087 124.701 41.6385 124.735 45.8141 124.768C50.266 124.804 54.6564 124.839 55.5001 127.5C51.0001 132.5 43.9312 150.681 49.0001 156C50.0643 157.809 51.5619 153.984 53.1676 149.882C55.565 143.759 58.2035 137.019 60.0001 147.5C63.0473 139.76 66.506 147.027 69.6374 153.606C71.6442 157.823 73.5166 161.756 75.06 161.277C78.7839 160.119 78.4681 153.705 78.1616 147.48C77.8502 141.156 77.5485 135.027 81.5001 134.8C81.7269 134.787 81.9569 134.785 82.1898 134.793C85.9446 136.954 89.9321 139.185 94.0253 140.239Z"
        fill="#9997B4"
      />
      <ellipse
        cx="208.833"
        cy="102.908"
        rx="8.15775"
        ry="12.7647"
        transform="rotate(-0.349837 208.833 102.908)"
        fill="#BAB8CE"
      />
      <ellipse
        cx="209.294"
        cy="102.915"
        rx="7.5"
        ry="12.4543"
        transform="rotate(-0.349837 209.294 102.915)"
        fill="#918FA5"
      />
      <ellipse
        cx="61.2978"
        cy="115.141"
        rx="7.7754"
        ry="6.66925"
        transform="rotate(76.6914 61.2978 115.141)"
        fill="#ACA9C3"
      />
      <ellipse
        cx="61.0003"
        cy="115.283"
        rx="7.07251"
        ry="6.01895"
        transform="rotate(76.6914 61.0003 115.283)"
        fill="#848297"
      />
      <ellipse
        cx="74.9077"
        cy="50.6446"
        rx="26.1571"
        ry="27.2661"
        transform="rotate(35.3937 74.9077 50.6446)"
        fill="#A4A1BC"
      />
      <ellipse
        opacity="0.8"
        cx="74.6161"
        cy="50.002"
        rx="24.8622"
        ry="26.5"
        transform="rotate(35.3937 74.6161 50.002)"
        fill="#8A889D"
      />
      <ellipse
        cx="163.262"
        cy="114.409"
        rx="21.7806"
        ry="24.8288"
        transform="rotate(-168.289 163.262 114.409)"
        fill="#BAB8CE"
      />
      <ellipse
        cx="163.836"
        cy="114.424"
        rx="20.8529"
        ry="24.0456"
        transform="rotate(-168.289 163.836 114.424)"
        fill="#918FA5"
      />
      <ellipse
        cx="174.492"
        cy="55.6454"
        rx="16.6197"
        ry="20.3011"
        transform="rotate(-31.0328 174.492 55.6454)"
        fill="#BAB8CE"
      />
      <ellipse
        cx="174.642"
        cy="55.2512"
        rx="16.2321"
        ry="19.7042"
        transform="rotate(-31.0328 174.642 55.2512)"
        fill="#918FA5"
      />
      <ellipse
        cx="159.925"
        cy="65.8014"
        rx="7.98261"
        ry="9.7587"
        transform="rotate(-31.0328 159.925 65.8014)"
        fill="#BAB8CE"
      />
      <ellipse
        cx="159.879"
        cy="65.4583"
        rx="7.28998"
        ry="8.98657"
        transform="rotate(-31.0328 159.879 65.4583)"
        fill="#908EA4"
      />
      <ellipse
        cx="198.439"
        cy="118.27"
        rx="5.03173"
        ry="7.61921"
        transform="rotate(6.61245 198.439 118.27)"
        fill="#BAB8CE"
      />
      <ellipse
        cx="198.673"
        cy="118.454"
        rx="4.40471"
        ry="7.29505"
        transform="rotate(6.61245 198.673 118.454)"
        fill="#918FA5"
      />
      <ellipse
        cx="63.7527"
        cy="190.722"
        rx="10.2513"
        ry="7.50893"
        transform="rotate(21.9421 63.7527 190.722)"
        fill="#BAB8CE"
      />
      <ellipse
        cx="63.4276"
        cy="191.043"
        rx="9.5"
        ry="7"
        transform="rotate(21.9421 63.4276 191.043)"
        fill="#8E8EA4"
      />
    </g>
  </svg>
);

export default Moon;
